import { render, staticRenderFns } from "./ImageUi.vue?vue&type=template&id=64733666&scoped=true"
import script from "./ImageUi.ts?vue&type=script&lang=ts&external"
export * from "./ImageUi.ts?vue&type=script&lang=ts&external"
import style0 from "./ImageUi.scss?vue&type=style&index=0&id=64733666&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64733666",
  null
  
)

export default component.exports